// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2sxgx","title":"card_title__24JTQ","inActive":"card_inActive__E_I6s"};